import { render } from "./PackagesAdults.vue?vue&type=template&id=1bc98cd0&scoped=true"
import script from "./PackagesAdults.vue?vue&type=script&lang=js"
export * from "./PackagesAdults.vue?vue&type=script&lang=js"

import "./PackagesAdults.vue?vue&type=style&index=0&id=1bc98cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc98cd0"]])

export default __exports__